module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_vm._v("The following memoir of Colonel Benjamin Tallmadge was prepared by himself, at the request of his children, and for their gratification. It is confined, principally, to those incidents of the Revolutionary War with which he was more immediately connected, and therefore becomes the more interesting to his descendants and family friends.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("For their convenience, and for the additional purpose of contributing to the authenticity of our Revolutionary History, I determined to publish this Memoir; and, as it terminates with the close of the Revolutionary struggle, I have added a brief sketch of his subsequent life.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("As a frontispiece, I have placed an engraved copy of a pencil sketch of my father, made by Colonel John Trumbull, soon after the close of the Revolutionary War, and which he presented to me, in frame, a few years before that venerated patriot’s death.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("I need not say how much I appreciate his kindness, in furnishing me with so spirited a sketch of my venerable ancestor, as well as the pride that is awakened and gratified, by receiving it from one of the Aids of Washington, and the companion-in-arms of my father,")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("F. A. TALLMADGE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-994bddbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-1-1.vue
// module id = 72
// module chunks = 0